import script from "./EmergencyContact.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencyContact.vue?vue&type=script&setup=true&lang=js"

import "./EmergencyContact.vue?vue&type=style&index=0&id=2fbc022a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fbc022a"]])

export default __exports__